/**
 * Salesforce member journey status surfaced by member-operations-service. The
 * raw `membershipStatus` mirrors the Salesforce package status; `accessReason`
 * is the derived enrollment access state. Both are `null` when no journey state
 * has synced for the member yet.
 */
export type MemberAccessReason =
  | 'active'
  | 'lapsed'
  | 'paused'
  | 'terminated'
  | 'not_started'
  | 'unknown';

export type MemberJourneyStatus = {
  membershipStatus: string | null;
  accessReason: MemberAccessReason | null;
};

export const MEMBER_JOURNEY_STATUS_QUERY_KEY = [
  'member-journey-status',
] as const;

export const memberJourneyStatusPath = (patientId: string): string =>
  `/v1/member-operations/members/${patientId}/journey-status`;

/** Human-readable label for an access reason (e.g. `not_started` → `Not started`). */
export const formatMemberAccessReason = (
  reason: MemberAccessReason | null | undefined,
): string | null => {
  if (!reason) {
    return null;
  }
  const spaced = reason.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
